/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
import {
  Container,
  Grid,
  Table,
  TableBody,
  TableHead,
  TableRow,
} from "@material-ui/core";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { globalColors } from "../../../../../../../_metronic/_assets/sass/custom/globalColors";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../../../../../partials/datatable/styles";
import { AppAPIService } from "../../../../../../services/AppAPIService";
import store from "../../../../../../store/store";
import Loading from "../../../../pages/../../home/components/Loading";
import { IconButton, Pagination, useMediaQuery } from "@mui/material";
import { ExpandIcon } from "../../../../../../components/IconsSVG";

export const PublicationsTable = (props) => {
  let api = AppAPIService.getInstance();
  const [loading, setLoading] = useState(false);
  const { auth } = store.getState();
  const srollableTable = useMediaQuery("(max-width: 768px)");

  const history = useHistory();

  const tableHeaders = [
    "E-mail",
    "WhatsApp",
    "Diário",
    "Vara",
    "Texto Original",
    "Data Publicação",
    "",
  ];
  const [publicationList, setPublicationList] = useState();
  const [meta, setMeta] = useState();
  const [page, setPage] = useState(1);
  const lawsuitId = props.lawsuitId;
  const setHasPublication = props.setHasPublication;

  const getPublicationList = useCallback(async () => {
    try {
      setLoading(true);
      const response = await api.makeHttpRequest({
        url: `/publications/${lawsuitId}?page=${page}&limit=10&isNotified=null&publicationDate=null`,
        method: "GET",
      });
      console.log(response.data);
      setPublicationList(response?.data);
      setMeta(response?.meta);
      if (response?.data?.length > 0) {
        setHasPublication(true);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [api, lawsuitId, page, setHasPublication]);

  useEffect(() => {
    setPublicationList([]);
    getPublicationList();
  }, [getPublicationList]);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  return (
    <Container
      style={{
        boxShadow: "none",
        padding: 0,
        margin: 0,
      }}
      maxWidth="xlx"
    >
      {loading ? <Loading /> : null}
      <Grid
        xl={12}
        lg={12}
        md={12}
        sm={12}
        xs={12}
        container
        style={{
          padding: 0,
        }}
      >
        <Container
          maxWidth="xxl"
          style={{
            boxShadow: "none",
            border: "1px solid #e0e0e0",
            borderRadius: "5px",
            padding: 0,
            textAlign: "left",
            maxWidth: srollableTable ? "calc(100vw - 70px)" : "100%",
            overflowX: srollableTable ? "scroll" : "hidden",
          }}
        >
          <Table
            className="table"
            style={{
              marginTop: "0px",
              marginBottom: "0px",
              padding: "0px",
              borderCollapse: "collapse",
              borderSpacing: "0px",
              width: "100%",
            }}
          >
            <TableHead
              style={{
                backgroundColor: globalColors.secondaryColor3,
              }}
            >
              <TableRow
                style={{
                  textAlign: "left",
                  backgroundColor: globalColors.secondaryColor3,
                }}
              >
                {tableHeaders.map((header, index) => (
                  <StyledTableCell
                    key={index}
                    style={{
                      textAlign: ["Data Publicação", "Notificado"].includes(
                        header
                      )
                        ? "center"
                        : "left",
                      backgroundColor: globalColors.secondaryColor3,
                      border: "none ",
                    }}
                  >
                    {header}
                  </StyledTableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody
              style={{
                textAlign: "left",
                backgroundColor: globalColors.colorWhite,
              }}
            >
              {publicationList &&
                publicationList.length > 0 &&
                publicationList?.map((row) => (
                  <StyledTableRow
                    key={row.id}
                    style={{
                      height: "50px",
                      backgroundColor:
                        row.id % 2 !== 0
                          ? "#fffff"
                          : "rgba(225, 222, 219, 0.25)",
                    }}
                  >
                    <StyledTableCell
                      style={{
                        padding: "4px 10px",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          width: "10px",
                          height: "10px",
                          borderRadius: "50%",
                          backgroundColor: row.isNotified
                            ? "#0b8a0b"
                            : "#b80808",
                          marginRight: "5px",
                          display: "inline-block",
                          verticalAlign: "middle",
                        }}
                      />
                      {row.isNotified ? "Sim" : "Não"}
                    </StyledTableCell>
                    <StyledTableCell
                      style={{
                        padding: "4px 10px",
                        textAlign: "center",
                      }}
                      title={row.whatsappLastError || ""}
                    >
                      <div
                        style={{
                          width: "10px",
                          height: "10px",
                          borderRadius: "50%",
                          backgroundColor: row.whatsappNotified
                            ? "#0b8a0b"
                            : "#b80808",
                          marginRight: "5px",
                          display: "inline-block",
                          verticalAlign: "middle",
                        }}
                      />
                      {row.whatsappNotified ? "Sim" : "Não"}
                    </StyledTableCell>
                    <StyledTableCell
                      style={{
                        padding: "4px 10px",
                        textAlign: "left",
                      }}
                    >
                      {row.dailyName}
                    </StyledTableCell>
                    <StyledTableCell
                      style={{
                        padding: "4px 10px",
                        textAlign: "left",
                      }}
                    >
                      {row.court}
                    </StyledTableCell>
                    <StyledTableCell
                      style={{
                        padding: "4px 10px",
                        textAlign: "justify",
                      }}
                    >
                      <p
                        style={{
                          textWrap: "wrap",
                        }}
                      >
                        {row.originalText.slice(0, 200) + "..."}
                      </p>
                    </StyledTableCell>
                    <StyledTableCell
                      style={{
                        padding: "4px 10px",
                        textAlign: "center",
                      }}
                    >
                      {new Date(row.publicationDate).toLocaleDateString(
                        "pt-BR"
                      )}
                    </StyledTableCell>
                    <StyledTableCell
                      style={{
                        padding: "4px 10px",
                        textAlign: "center",
                      }}
                    >
                      <IconButton
                        size="small"
                        title="Visualizar"
                        style={{
                          width: "30px",
                          height: "30px",
                          color: "#cacaca",
                        }}
                        onClick={() => {
                          props.setPublication(row);
                          props.togglePublicationModal();
                        }}
                      >
                        <ExpandIcon />
                      </IconButton>
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
            </TableBody>
          </Table>
        </Container>
      </Grid>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <Pagination
          count={meta?.pageCount ?? 0}
          page={meta?.page ?? 0}
          onChange={handlePageChange}
          showFirstButton={meta?.hasPreviousPage ?? false}
          showLastButton={meta?.hasNextPage ?? false}
          siblingCount={0}
          boundaryCount={1}
        />
      </div>
    </Container>
  );
};
